import React from "react";
import Section from "../../../components/section/section";
import { WelcomeAdminContext } from "./context/welcomeAdminContext";
import IApiState from "./interface/iApiState";
import NextDays from "./src/nextDays";
import LastRatings from "./src/lastRatings";

const WelcomeAdminContainer = (): React.JSX.Element => {
  const {
    apiState,
  }: {
    apiState: React.MutableRefObject<IApiState>;
  } = React.useContext(WelcomeAdminContext);

  return (
    <Section>
      {apiState.current.fetched && (
        <React.Fragment>
          <NextDays />
          <LastRatings />
        </React.Fragment>
      )}
    </Section>
  );
};

export default WelcomeAdminContainer;
